import { Quill } from "react-quill-new";

const Embed = Quill.import("blots/embed");

class TaskReferenceBlot extends Embed {
  static create(value) {
    const node = super.create();
    node.setAttribute("data-task-id", value.boardTaskId || "");
    node.setAttribute("data-board-id", value.boardId || "");
    node.setAttribute("data-task-db-id", value.taskId || "");
    node.setAttribute("contenteditable", "false");
    node.textContent = value.boardTaskId || "";
    return node;
  }

  static value(node) {
    return {
      boardTaskId: node.getAttribute("data-task-id"),
      boardId: node.getAttribute("data-board-id"),
      taskId: node.getAttribute("data-task-db-id"),
    };
  }
}

TaskReferenceBlot.blotName = "task-reference";
TaskReferenceBlot.tagName = "span";
TaskReferenceBlot.className = "task-reference";

Quill.register(TaskReferenceBlot);

export default TaskReferenceBlot;
